module.exports = __webpack_public_path__ + "static/media/Pizza_PHP.14178e6f.png";